/**
 * Chemins du SPA où un visiteur peut naviguer sans session valide.
 * Réutilisé par la bulle support et par l’intercepteur API (401 → pas de redirection violente vers /login).
 */
const EXACT_PUBLIC_PATHS = new Set([
  '/',
  '/pricing',
  '/about',
  '/contact',
  '/accessibility',
  '/le-bref',
  '/blog',
  '/store',
  '/use-cases',
  '/partners',
  '/privacy',
  '/terms',
  '/cookies',
]);

const AUTH_PATHS = new Set([
  '/login',
  '/register',
  '/establishment/register',
  '/forgot-password',
  '/reset-password',
]);

export function isAuthPath(pathname: string): boolean {
  return AUTH_PATHS.has(pathname);
}

/** True si la page actuelle est marketing, légale ou auth : une 401 ne doit pas imposer /login (jeton expiré). */
export function isPublicOrAuthPath(pathname: string): boolean {
  if (EXACT_PUBLIC_PATHS.has(pathname)) return true;
  if (pathname.startsWith('/blog/') || pathname.startsWith('/store/')) return true;
  if (AUTH_PATHS.has(pathname)) return true;
  // Webinar public flow: login is handled inline on the page.
  if (pathname.startsWith('/webinars/live/')) return true;
  if (pathname.startsWith('/webinars/register/')) return true;
  if (pathname.startsWith('/podcasts/public') || pathname.startsWith('/podcasts/learner')) return true;
  if (/^\/eduflow\/flows\/[^/]+\/public$/.test(pathname)) return true;
  if (pathname.startsWith('/eduflow/participant/')) return true;
  if (/^\/f\/[^/]+$/.test(pathname)) return true;
  return false;
}
